var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpgoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 60,
    viewBox: "0 0 116 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.896 40.9964V11.6703H8.52972V23.3588H10.088V29.1403H8.52972V40.9964H2.896ZM12.2855 29.1403V23.3588H13.8438V11.6703H19.4775V40.9964H13.8438V29.1403H12.2855Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.594 34.5027V23.5264C22.6207 22.1579 23.22 20.8172 24.392 19.5046C25.8304 17.9405 27.5885 17.1445 29.6661 17.1166V22.3953C28.8937 22.3953 28.3609 22.7444 28.0679 23.4426C27.988 23.6102 27.9481 23.7638 27.9481 23.9035V25.9982H33.9014V23.9454C33.8748 22.912 33.1822 22.3953 31.8237 22.3953V17.1166C33.7682 17.1166 35.473 17.8148 36.938 19.2113C38.2166 20.4402 38.8692 21.8646 38.8959 23.4845V31.4026H27.9481V34.5027C28.1345 35.3127 28.7205 35.7596 29.7061 35.8434V40.9964C27.2022 40.9964 25.2178 39.9211 23.7527 37.7705C22.9803 36.6254 22.594 35.5361 22.594 34.5027ZM31.8237 40.9964V35.8852C33.2621 35.8573 34.1811 35.1451 34.5807 33.7486L38.9358 35.4663C38.5363 37.2538 37.5241 38.6922 35.8992 39.7814C34.6473 40.5914 33.2888 40.9964 31.8237 40.9964Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1323 40.9964V11H47.8858V40.9964H42.1323Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7537 40.9964V35.5501H60.1122C60.9912 35.4942 61.524 35.1172 61.7104 34.4189V23.694C61.7104 23.3309 61.4973 23.0237 61.0711 22.7723C60.7781 22.6327 60.4585 22.5628 60.1122 22.5628H58.7537V17.1166H60.1122C62.6161 17.1166 64.5606 18.2338 65.9457 20.4681C66.6383 21.6132 66.9845 22.6606 66.9845 23.6102V34.5027C66.9845 35.7875 66.4518 37.1002 65.3863 38.4408C63.9746 40.1166 62.2165 40.9684 60.1122 40.9964H58.7537ZM51.1222 49.3333V17.1166H56.7559V49.3333H51.1222Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4189 49.3336L79.3346 45.6025H85.1832C85.8133 45.5822 86.217 45.289 86.3942 44.7228C86.4139 44.6823 86.4238 44.652 86.4238 44.6318V43.2061C86.0102 43.2869 85.5672 43.3274 85.0946 43.3274V39.5659C85.9413 39.5255 86.3844 39.1918 86.4238 38.5649V30.8296C86.4238 30.5465 86.2465 30.2937 85.8921 30.0713C85.6558 29.9297 85.3899 29.8589 85.0946 29.8589V26.0671C85.5672 26.0671 86.0102 26.1278 86.4238 26.2491V26.0671H90.2046V44.6318C90.2046 45.5216 89.8206 46.4417 89.0527 47.3922C88.0287 48.6662 86.7585 49.3134 85.2422 49.3336H78.4189ZM78.7143 38.6559V30.678C78.734 29.7073 79.1574 28.7568 79.9845 27.8265C81.0085 26.6738 82.2884 26.0874 83.8244 26.0671V29.8589C83.1155 29.8589 82.6626 30.1218 82.4657 30.6476C82.446 30.7083 82.4361 30.7487 82.4361 30.769V38.6256C82.4361 39.0907 82.7217 39.3839 83.2927 39.5053C83.4503 39.5457 83.6275 39.5659 83.8244 39.5659V43.3274C81.9734 43.3274 80.5358 42.5286 79.5119 40.931C78.9802 40.1221 78.7143 39.3637 78.7143 38.6559Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.42 38.8682V30.951C92.42 29.96 92.8434 28.9893 93.6901 28.0389C94.7535 26.8862 96.1024 26.2997 97.7368 26.2795V30.2229C96.8507 30.3038 96.3781 30.6881 96.319 31.3757V38.4436C96.3584 39.2323 96.831 39.6367 97.7368 39.6569V43.6004C95.807 43.6004 94.3104 42.8016 93.2471 41.204C92.6957 40.3748 92.42 39.5963 92.42 38.8682ZM99.0956 43.6004V39.6569C99.9227 39.5558 100.376 39.1716 100.454 38.5042L100.425 31.3757C100.287 30.6476 99.8341 30.2634 99.0661 30.2229V26.2795C100.917 26.2795 102.364 27.0479 103.408 28.5849C103.96 29.414 104.235 30.2027 104.235 30.951V38.8682C104.235 39.8794 103.812 40.8703 102.965 41.841C101.941 42.9937 100.651 43.5802 99.0956 43.6004Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5618,
    y: 35.7317,
    width: 0.472609,
    height: 0.9707,
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0347,
    y: 34.2756,
    width: 0.945219,
    height: 3.8828,
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.0957,
    y: 28.9578,
    width: 0.472609,
    height: 14.5605,
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1784 28.5237C69.8992 28.5237 69.3392 44.0549 77.1784 44.0549V28.5237Z",
    fill: "#718096"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.151,
    y: 35.7317,
    width: 0.472609,
    height: 0.9707,
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.206,
    y: 34.2756,
    width: 0.945219,
    height: 3.8828,
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.452,
    y: 28.9578,
    width: 0.472609,
    height: 14.5605,
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.924 28.4727C113.204 28.4727 113.764 44.0039 105.924 44.0039V28.4727Z",
    fill: "#718096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4038 14.3972C89.166 10.4206 94.1321 10.3829 103.089 14.3972",
    stroke: "#1A202C",
    strokeWidth: 0.898438
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5618 36.2896C68.241 2.34946 115.516 2.79153 112.624 36.2896",
    stroke: "#1A202C",
    strokeWidth: 0.598958
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpgoLogo);
export default __webpack_public_path__ + "static/media/helpgo-logo.9d66130955e3739ff9efa16fe806b62f.svg";
export { ForwardRef as ReactComponent };